import script from "./NotificationsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsWidget.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsWidget.vue?vue&type=style&index=0&id=1fd36e90&scoped=true&lang=css"

import exportComponent from "../../../author/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd36e90"]])

export default __exports__